// rcfe
import React from "react";
import { Route, BrowserRouter as Router, Switch, Link } from "react-router-dom";

import Header from "./Header";
import Footer from "./Footer";
import Menu from "./Menu";
import Content from "./Content";

function Home() {
  return (
    <div className="content-wrapper">
      <h2>Home page</h2>      
    </div>
  );
}

export default Home;
